// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"dhsg2P6ot-titleContainer","aspect1":"dhsg2B36k-aspect1","aspect2":"dhsg3DEBe-aspect2"};